import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCurrentUserCandidatures } from "../../redux/candidatureSlice";
import {
  Box,
  Typography,
  Alert,
  IconButton,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import AssignmentIcon from "@mui/icons-material/Assignment";
import BusinessIcon from "@mui/icons-material/Business";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import { getColorForStatus } from "../../utils/utils";
import CustomLoader from '../Common/CustomLoader';
import "./styles/MyCandidatures.css";

const PRIMARY_COLOR = "#2F4E8B"; // Define primary color for icons

const MyCandidatures = () => {
  const dispatch = useDispatch();
  const { candidatures, loading, error } = useSelector(
    (state) => state.candidatures
  );

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 3;
  const totalPages = Math.ceil(candidatures.length / itemsPerPage);

  const paginate = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const currentCandidatures = candidatures.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  useEffect(() => {
    dispatch(fetchCurrentUserCandidatures());
  }, [dispatch]);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CustomLoader />
      </Box>
    );
  }

  if (error) return <Alert severity="error">{error}</Alert>;

  // Ensure we have an array
  const candidaturesArray = Array.isArray(candidatures) ? candidatures : [];

  return (
    <Box className="mycandidatures-container-offre">
      {candidaturesArray.length === 0 ? (
        <Typography>Aucune candidature trouvée.</Typography>
      ) : (
        <Box>
          {currentCandidatures.map((candidature) => (
            <Box key={candidature.id} className="mycandidature-card">
              {/* Status at the top right */}
              <Box
                className="mycandidature-status"
                style={{
                  backgroundColor: getColorForStatus(candidature.status),
                }}
              >
                {candidature.status || "Non spécifié"}
              </Box>

              <Box className="mycandidature-content">
                <Typography className="mycandidature-info">
                  <AssignmentIcon className="mycandidature-icon" />
                  <span>
                    <strong>Date de création:</strong> {candidature.createdAt}
                  </span>
                </Typography>

                <Typography className="mycandidature-info">
                  <BusinessIcon className="mycandidature-icon" />
                  <span>
                    <strong>Commentaire:</strong>{" "}
                    {candidature.commentaire || "N/A"}
                  </span>
                </Typography>

                <Typography className="mycandidature-info">
                  <AssignmentIcon className="mycandidature-icon" />
                  <span>
                    <strong>Appel d'Offre Référence:</strong>{" "}
                    {candidature.appelOffre?.reference || "Non spécifié"}
                  </span>
                </Typography>

                <Typography className="mycandidature-info">
                  <BusinessIcon className="mycandidature-icon" />
                  <span>
                    <strong>Référence Client:</strong>{" "}
                    {candidature.appelOffre?.reference_client || "Non spécifié"}
                  </span>
                </Typography>

                <Typography className="mycandidature-info">
                  <BusinessCenterIcon className="mycandidature-icon" />
                  <span>
                    <strong>Titre:</strong>{" "}
                    {candidature.appelOffre?.titre || "Non spécifié"}
                  </span>
                </Typography>
              </Box>
            </Box>
          ))}

          {/* Updated Pagination */}
          {candidaturesArray.length > itemsPerPage && (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              mt={4}
              gap={2}
            >
              <IconButton
                onClick={() => paginate(currentPage - 1)}
                disabled={currentPage === 1}
              >
                <ArrowBackIosIcon sx={{ color: PRIMARY_COLOR }} />
              </IconButton>
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                  bgcolor: PRIMARY_COLOR,
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: 700,
                }}
              >
                {currentPage}
              </Box>
              <IconButton
                onClick={() => paginate(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                <ArrowForwardIosIcon sx={{ color: PRIMARY_COLOR }} />
              </IconButton>
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};

export default MyCandidatures;
